<!-- =========================================================================================
    File Name: VxBreadcrumb.vue
    Description: Breadcrumb component
    Component Name: VxBreadcrumb
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="vx-breadcrumb">
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2"><feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" /></span>
            </li>
            <li v-for="(link, index) in breadcrumbLinks" :key="index" class="inline-flex items-center">
                <router-link :to="link.url" v-if="link.url">{{ translateTitle(link.title) }}</router-link>
                <span class="text-primary cursor-default" v-else>{{ translateTitle(link.title) }}</span>
                <span class="breadcrumb-separator mx-2 flex items-start"><feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex">
                <span v-if="activeBreadcrumbItem && activeBreadcrumbItem.active" class="cursor-default">{{ translateTitle(activeBreadcrumbItem.title) }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default{
    name: 'vx-breadcrumb',
    props: {
        route: { type: Object, required: true },
        isRTL: { type: Boolean, default: false }
    },
    computed: {
        breadcrumbItems() {
            return Array.isArray(this.route.meta.breadcrumb) ? this.route.meta.breadcrumb : []
        },
        breadcrumbLinks() {
            return this.breadcrumbItems.slice(1, -1)
        },
        activeBreadcrumbItem() {
            return this.breadcrumbItems[this.breadcrumbItems.length - 1]
        }
    },
    methods: {
        translateTitle(title) {
            return typeof title === 'string' && title.length > 0 ? this.$t(title) : ''
        }
    }
}
</script>
